import React from 'react';
import axios from 'axios';
import { uniqueCheck } from 'account-portal-library/lib/idmRegister';
import CreateUserFormView from '../../Views/TO/Register/Local/CreateUserFormView';

import AppVars from '../../../AppVars.js';
import pushAnalytics from '../../../analytics/pushAnalytics.js';
const appVars = AppVars.getInstance()

const INPUT_VALIDATION = {
    "FIRST_NAME": "^[a-zA-Z][a-zA-Z\\s'\-]{0,12}[a-zA-Z]$",
    "LAST_NAME": "^[a-zA-Z][a-zA-Z\\s'\-]{0,27}[a-zA-Z]$",
    "EMAIL": "(^[0-9A-Z_a-z][-0-9A-Z_a-z]*(\\.[-0-9A-Z_a-z]+)*@([0-9A-Z_a-z][-0-9A-Z_a-z]*(\\.[-0-9A-Z_a-z]+)*\\.(AERO|ARPA|BIZ|COM|COOP|EDU|GOV|INFO|INT|LAW|MIL|MOBI|MUSEUM|NAME|NET|ORG|PRO|TRAVEL|aero|arpa|biz|com|coop|edu|gov|info|int|law|mil|mobi|museum|name|net|org|pro|travel|[A-Za-z][A-Za-z])|([0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}))(:[0-9]{1,5})?$)",
    "PHONE": "^(?!0)[0-9]{10}$"
}

const RESPONSE_CODES = {
    CREATED: "M00000",
    IN_USE: "M00206",
    USED_PHONE: "M06010"
}

const ENTRY_ERROR = 'km-form_field_entry-error';
const REGISTER_FORM = 'register-form';
const SYS_ACTION = 'sys-action';

const COMPONENT_TREE = [
    { component_name: 'RegisterForm', component_version: '1.0.0' },
    { component_name: 'CreateUserForm', component_version: '1.0.0' }
];

class CreateUserForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props,
            firstName: "",
            lastName: "",
            email: this.props.email,
            phone: "",
            password: "",
            showPassword: false,
            responseCode: null,
            loading: false,
            floatFirstName: true,
            floatLastName: true,
            floatPassword: true,
            floatPhone: true,
            firstNameFocus: false,
            lastNameFocus: false,
            phoneFocus: false,
            passwordFocus: false,
            isFirstNameValid: null,
            isLastNameValid: null,
            isEmailValid: null,
            isPhoneValid: null,
            isPasswordLength: null,
            isPasswordCase: null,
            isPasswordNumber: null,
            isPasswordSpecial: null,
            isPasswordValid: null,
            isResponseValid: this.props.isResponseValid,
            isEmailAvailable: null,
            isPhoneAvailable: null
        };
        this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
        this.handleLastNameChange = this.handleLastNameChange.bind(this);
        this.handlePhoneChange = this.handlePhoneChange.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.setFocusFirstName = this.setFocusFirstName.bind(this);
        this.setFocusLastName = this.setFocusLastName.bind(this);
        this.setFocusPhone = this.setFocusPhone.bind(this);
        this.setFocusPassword = this.setFocusPassword.bind(this);
        this.removeFocusFirstName = this.removeFocusFirstName.bind(this);
        this.removeFocusLastName = this.removeFocusLastName.bind(this);
        this.removeFocusPhone = this.removeFocusPhone.bind(this);
        this.removeFocusPassword = this.removeFocusPassword.bind(this);
        this.onBlurFirstName = this.onBlurFirstName.bind(this);
        this.onBlurLastName = this.onBlurLastName.bind(this);
        this.onBlurPhone = this.onBlurPhone.bind(this);
        this.onBlurPassword = this.onBlurPassword.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.showHidePassword = this.showHidePassword.bind(this);
    }

    async handleFormSubmit(event) {
        event.preventDefault();
        this.setState({ loading: true });
        const isValid = this.validateFormInput();
        if (!isValid) {
            this.setState({ loading: false });
            return;
        }
        try {
            const response = await this.createDCSUser();
            const code = response?.data?.status?.messages?.[0]?.code;
            if (code === RESPONSE_CODES.CREATED) {
                this.props.displayForm("COMPLETE");
            } else if (code === RESPONSE_CODES.USED_PHONE) {
                this.setState({ isPhoneAvailable: false });
            }
        } catch (error) {
        } finally {
            this.setState({ loading: false });
        }
    }

    async createDCSUser() {
        const headers = {
            "x-brand": "T",
            "x-client": "FR-Portal-Toyota"
        }

        const body = {
            "firstName": this.state.firstName,
            "lastName": this.state.lastName,
            "registrationSource": "SI-REG",
            "email": this.props.email,
            "password": this.state.password,
            "areaCode": this.state.phone.substr(0, 3),
            "phoneNumber": this.state.phone.substr(3),
            "redirectURI": this.props.loginURI
        }

        const url = appVars.getAPIGatewayURL() + "/Creation"

        try {
            const response = await axios({ method: 'POST', url, headers, data: body });
            this.handleResponse(response);
            return response;
        } catch (err) {
            this.handleErrorResponse(err);
        }
    }

    handleResponse(createUserResponse) {
        if (createUserResponse.status > 299) {
            this.setState({
                responseCode: createUserResponse.status,
                isResponseValid: false
            });
        } else {
            const code = createUserResponse.data.status.messages[0].code;
            this.setState({
                responseCode: code,
                isResponseValid: true
            });
        }
    }

    handleErrorResponse(err) {
        const errorMessages = err.response?.data?.status?.messages || [];
        const errorCode = errorMessages[0]?.code;
        this.setState({ responseCode: errorCode });
        if (errorMessages[0]?.description !== 'PhoneNumber already in use') {
            this.setState({ isResponseValid: false });
        } else {
            this.setState({ isResponseValid: true, isPhoneAvailable: false });
        }
    }

    /*validateFormInput() {
        const isFirstNameValid = this.validateInput(this.state.firstName, "FIRST_NAME");
        const isLastNameValid = this.validateInput(this.state.lastName, "LAST_NAME");
        const isPhoneValid = this.validateInput(this.state.phone, "PHONE")
        const passwordValid = this.checkCharacters(this.state.password) && this.checkLength(this.state.password)
        const isPasswordValid = passwordValid
        this.setState({ isFirstNameValid: isFirstNameValid });
        this.setState({ isLastNameValid: isLastNameValid });
        this.setState({ isPhoneValid: isPhoneValid })
        this.setState({ isPasswordValid: isPasswordValid })
        return (isFirstNameValid && isLastNameValid && isPhoneValid && isPasswordValid)
    }*/
    validateFormInput() {
        const { firstName, lastName, phone, password } = this.state;

        const isFirstNameValid = this.validateInput(firstName, "FIRST_NAME");
        const isLastNameValid = this.validateInput(lastName, "LAST_NAME");
        const isPhoneValid = this.validateInput(phone, "PHONE");
        const isPasswordValid = this.checkCharacters(password) && this.checkLength(password);

        // Single setState (Sonar-compliant)
        this.setState({ isFirstNameValid, isLastNameValid, isPhoneValid, isPasswordValid });

        if (!isFirstNameValid) {
            pushAnalytics(SYS_ACTION, { form_name: REGISTER_FORM, field_name: 'first-name', error_type: 'validation', metrics: ENTRY_ERROR }, COMPONENT_TREE);
        }
        if (!isLastNameValid) {
            pushAnalytics(SYS_ACTION, { form_name: REGISTER_FORM, field_name: 'last-name', error_type: 'validation', metrics: ENTRY_ERROR }, COMPONENT_TREE);
        }
        if (!isPhoneValid) {
            pushAnalytics(SYS_ACTION, { form_name: REGISTER_FORM, field_name: 'phone', error_type: 'validation', metrics: ENTRY_ERROR }, COMPONENT_TREE);
        }
        if (!isPasswordValid) {
            pushAnalytics(SYS_ACTION, { form_name: REGISTER_FORM, field_name: 'password', error_type: 'validation', metrics: ENTRY_ERROR }, COMPONENT_TREE);
        }

        return (isFirstNameValid && isLastNameValid && isPhoneValid && isPasswordValid);
    }


    validateInput(inputValue, inputType) {
        const regex = RegExp(INPUT_VALIDATION[inputType])
        if (regex.test(inputValue)) {
            if (inputType === "EMAIL" && (inputValue.includes("mailinator") || inputValue.includes("yopmail") || inputValue.length < 5 || inputValue.length > 128)) {
                return false;
            }
            return true;
        }
        return false;
    }

    handleFirstNameChange(event) {
        this.setState({ firstName: event.target.value });
        this.setState({ isFirstNameValid: this.validateInput(event.target.value, "FIRST_NAME") })
    }

    handleLastNameChange(event) {
        this.setState({ lastName: event.target.value });
        this.setState({ isLastNameValid: this.validateInput(event.target.value, "LAST_NAME") })
    }

    handlePhoneChange(event) {
        this.setState({
            phone: event.target.value.replace("-", "")
        }, () => {
            if (!this.state.isPhoneAvailable) {
                this.setState({
                    isPhoneAvailable: true,
                    isPhoneValid: this.validateInput(this.state.phone, "PHONE")
                })
            } else {
                this.setState({
                    isPhoneValid: this.validateInput(this.state.phone, "PHONE")
                })
            }
        })
    }

    setFocusFirstName(event) {
        this.setState({ firstNameFocus: true })
        this.setState({ floatFirstName: false })
    }

    removeFocusFirstName() {
        this.setState({ firstNameFocus: false })
    }

    setFocusLastName(event) {
        this.setState({ lastNameFocus: true })
        this.setState({ floatLastName: false })
    }

    removeFocusLastName() {
        this.setState({ lastNameFocus: false })
    }

    setFocusPhone(event) {
        this.setState({ phoneFocus: true })
        this.setState({ floatPhone: false })
    }

    removeFocusPhone() {
        this.setState({ phoneFocus: false })
    }


    setFocusPassword(event) {
        this.setState({ passwordFocus: true })
        this.setState({ floatPassword: false })
        // this.setState({isPasswordValid: this.checkCharacters(event.target.value) && this.checkLength(event.target.value)})
    }

    removeFocusPassword(event) {
        this.setState({ passwordFocus: false })
        // this.setState({isPasswordValid: this.checkCharacters(this.state.password) && this.checkLength(this.state.password)})
    }

    hideModal() {
        this.setState({ isResponseValid: null })
    }

    showHidePassword() {
        this.setState({ showPassword: !this.state.showPassword })
    }

    onBlurFirstName() {
        if (this.state.firstName === "") {
            this.setState({ floatFirstName: true })
        } else {
            this.setState({ floatFirstName: false })
        }
        this.removeFocusFirstName();

        this.setState({ isFirstNameValid: this.validateInput(this.state.firstName, "FIRST_NAME") })
    }

    onBlurLastName() {
        if (this.state.lastName === "") {
            this.setState({ floatLastName: true })
        } else {
            this.setState({ floatLastName: false })
        }
        this.removeFocusLastName();
        this.setState({ isLastNameValid: this.validateInput(this.state.lastName, "LAST_NAME") })
    }

    onBlurPhone() {
        if (this.state.phone === "") {
            this.setState({ floatPhone: true })
        } else {
            this.setState({ floatPhone: false })
        }
        this.removeFocusPhone();
        this.setState({
            isPhoneValid: this.validateInput(this.state.phone, "PHONE")
        })
    }

    onBlurPassword() {
        if (this.state.password === "") {
            this.setState({ floatPassword: true })
        } else {
            this.setState({ floatPassword: false })
        }
        this.removeFocusPassword();
        this.setState({ isPasswordValid: this.checkCharacters(this.state.password) && this.checkLength(this.state.password) })
    }


    handlePasswordChange(event) {
        this.setState({ password: event.target.value })
        this.setState({ isPasswordLength: this.checkLength(event.target.value) })
        this.setState({ isPasswordCase: this.checkLower(event.target.value) && this.checkUpper(event.target.value) })
        this.setState({ isPasswordNumber: this.checkNumber(event.target.value) })
        this.setState({ isPasswordSpecial: this.checkSpecial(event.target.value) })
        this.setState({ isPasswordValid: this.checkCharacters(event.target.value) && this.checkLength(event.target.value) })
    }

    checkLength(password) {
        if (password.length >= 8 && password.length <= 16) {
            return true
        } else {
            return false
        }
    }

    checkCharacters(password) {
        let true_count = 0
        if (this.checkSpecial(password)) {
            true_count = true_count + 1
        }
        if (this.checkNumber(password)) {
            true_count = true_count + 1
        }
        if (this.checkLower(password)) {
            true_count = true_count + 1
        }
        if (this.checkUpper(password)) {
            true_count = true_count + 1
        }

        if (true_count >= 4) {
            return true
        } else {
            return false
        }
    }

    checkSpecial(password) {
        //    return false;
        const specialChars = '!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~';
        let totalSpecialChars = 0;
        password.split("").forEach(passchar =>
            specialChars.split("").forEach(specialchar => {
                if (passchar == specialchar) {
                    totalSpecialChars = totalSpecialChars + 1
                    return true
                }
                return false
            }
            )
        )
        if (totalSpecialChars > 0) {
            return true
        } else {
            return false
        }
    }

    checkNumber(password) {
        const regex = RegExp(/(.*[0-9])/)
        if (regex.test(password)) {
            return true
        } else {
            return false
        }
    }

    checkLower(password) {
        if (password === password.toUpperCase()) {
            return false
        } else {
            return true
        }
    }

    checkUpper(password) {
        if (password === password.toLowerCase()) {
            return false
        } else {
            return true
        }
    }

    render() {
        return (
            <CreateUserFormView
                firstName={this.state.firstName}
                lastName={this.state.lastName}
                email={this.state.email}
                phone={this.state.phone}
                password={this.state.password}
                showPassword={this.state.showPassword}
                showHidePassword={this.showHidePassword}
                firstNameFocus={this.state.firstNameFocus}
                lastNameFocus={this.state.lastNameFocus}
                phoneFocus={this.state.phoneFocus}
                passwordFocus={this.state.passwordFocus}
                loading={this.state.loading}
                isFirstNameValid={this.state.isFirstNameValid}
                isLastNameValid={this.state.isLastNameValid}
                isPhoneValid={this.state.isPhoneValid}
                isPhoneAvailable={this.state.isPhoneAvailable}
                isPasswordLength={this.state.isPasswordLength}
                isPasswordCase={this.state.isPasswordCase}
                isPasswordNumber={this.state.isPasswordNumber}
                isPasswordSpecial={this.state.isPasswordSpecial}
                isPasswordValid={this.state.isPasswordValid}
                isResponseValid={this.state.isResponseValid}
                handleFirstNameChange={this.handleFirstNameChange}
                handleLastNameChange={this.handleLastNameChange}
                handlePhoneChange={this.handlePhoneChange}
                handlePasswordChange={this.handlePasswordChange}
                handleFormSubmit={this.handleFormSubmit}
                setFocusFirstName={this.setFocusFirstName}
                setFocusLastName={this.setFocusLastName}
                setFocusPhone={this.setFocusPhone}
                setFocusPassword={this.setFocusPassword}
                removeFocusFirstName={this.removeFocusFirstName}
                removeFocusLastName={this.removeFocusLastName}
                removeFocusPhone={this.removeFocusPhone}
                removeFocusPassword={this.removeFocusPassword}
                onBlurFirstName={this.onBlurFirstName}
                onBlurLastName={this.onBlurLastName}
                onBlurPhone={this.onBlurPhone}
                onBlurPassword={this.onBlurPassword}
                floatFirstName={this.state.floatFirstName}
                floatLastName={this.state.floatLastName}
                floatPhone={this.state.floatPhone}
                floatPassword={this.state.floatPassword}
                style={this.props.style}
            />
        );
    }
}

export default CreateUserForm;